module.exports = __webpack_public_path__ + "img/brand-block-4.57121350.png";